import { Component } from 'react';
import Main from '../../layout/main';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import axios from "axios";
import API from "../../API";
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import 'swiper/swiper.scss';
import './dashboard.scss';
import { activateChatBox } from "../../redux/actions/chatboxActive";
import Cookies from 'js-cookie';
SwiperCore.use([Navigation, Autoplay]);
class DashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [],
      advertisements: [],
      deals_available: [],
      stories: [],
      reviews: [],
      primaryNotification: [],
      primaryModelOpen: true,
      user_name: Cookies.get('name'),
      notification_count: 0,
      showModal: false,
      popup_video_url: '',
      removeLoding: false,
      search:''
    };

    this.markNotificationRead = this.markNotificationRead.bind(this);
  }

  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    // Fetch dashboard data
    axios.get(
      API.baseURL + `/customer-dashboard`,
      API.options
    )
    .then(response => response.data)
    .then(res => {
      this.setState({
        advertisements: res.ads,
        deals_available: res.deals_available || [],
        // services: res.featured,
        stories: res.stories,
        reviews: res.reviews,
        user_name: Cookies.get('name'),
      });
      // localStorage.setItem("name", res.user_name);
    })
    .catch((error) => {
      console.log(error, "Error fetching dashboard data");
      if (error?.response?.status === 401)
        window.location.href = `/logout`;
    });


    axios.get(
      API.baseURL + `/service-search`,
      API.options
    )
    .then(response => response.data)
    .then(res => {
      console.log(res, "res");
      this.setState({
        services: res,
      });
    })
    .catch((error) => {
      if (error?.response?.status === 401)
        window.location.href = `/logout`;
    });

    // Fetch notification count
    axios.get(
      API.baseURL + `/customer-notification`,
      API.options
    )
    .then(response => response.data)
    .then(res => {
      this.setState({
        notification_count: res.customer_notification,
      });
    })
    .catch((error) => {
      if (error?.response?.status === 401)
        window.location.href = `/logout`;
    });

    // Fetch primary notifications
    axios.get(
      API.baseURL + `/v2/customers/notifications`,
      API.options
    )
    .then(response => response.data)
    .then(response => response.data)
    .then(res => {
      this.setState({
        primaryNotification: res?.notification,
        primaryModelOpen: true
      });
    })
    .catch((error) => {
      if (error?.response?.status === 401)
        window.location.href = `/logout`;
    });
  }

  markNotificationRead(notification_id) {
    axios.put(
      API.baseURL + `/v2/customers/notifications/${notification_id}/read`,
      {},
      API.options
    )
    .then(response => response.data)
    .then(res => {
      this.setState({
        primaryNotification: [],
        primaryModelOpen: false
      });
    })
    .catch((error) => {
      console.log(error);
    });
  }

  removeNotification = (pnId) => {
    this.setState({ removeLoding: true });
    axios.delete(
      API.baseURL + `/v2/customers/notifications/${pnId}`,
      API.options
    )
    .then(response => response.data)
    .then(() => {
      // Refresh notifications after removal
      return axios.get(API.baseURL + `/v2/customers/notifications`, API.options);
    })
    .then(response => response.data)
    .then(response => response.data)
    .then(res => {
      this.setState({
        primaryNotification: res?.notification,
        removeLoding: false,
      });
    })
    .catch(error => console.log(error));
  }

  render() {
    const { services } = this.state;
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="description" content="Check out all your Data about EasyBids at a single place.The projects you bidded,avaible projects around locality  and the bids approved.Check everything at a single place" />
          <title>EasyBids - Home Improvements :: Dashboard</title>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
        </Helmet>
        <Main additionalClass_main="dashboard pt-0">
          <div style={{backgroundImage: "url(/images/home-new/home-profile.jpg)", backgroundPosition: "top"}}
               className="ec-headern__wrap ec-headern__wrap-fullwidth">
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-10 col-lg-10 mx-auto">
                  <div className="ec-headern__inwrap">
                    <div className="ec-headern__row ec-headern__home d-flex justify-content-between">
                      <div className="ec-headern__left">
                        <div className="ec-headern__title-wrap">
                          <div className="ec-headern__subtitle">Welcome back</div>
                          <div className="ec-headern__title">{this.state.user_name}</div>
                        </div>
                      </div>
                    </div>

                    <div className="ec-search ec-homen__search mb-5">
                      <div className="ec-input__search d-flex align-items-center">
                        <div className="icon-search ec-text--L mr-2"></div>
                        <input
                            type="text"
                            placeholder="Search for services"
                            className="ec-text--S border-0 bg-transparent w-100"
                            style={{outline: 'none'}}
                            value={this.state.search}
                            onChange={(e) => this.setState({search: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section className="ebw-section__pages">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-10 col-lg-10 mx-auto">
                    <div className="ec-homen__projects mb-3 mt-3">
                      <div className="ec-title text-center mb-5">START YOUR PROJECT TODAY</div>
                      <div className="row ec-project__cards justify-content-center">
                        {services?.length > 0
                            ? services
                                .filter(service =>
                                    service.title.toLowerCase().includes(this.state.search.toLowerCase())
                                )
                                .map((service, i) => (
                                    <div className="col-3 mb-4" key={i}>
                                      <Link className="ec-card ec-card__secondary w-100 dblock mb-0"
                                            to={`/project-category/${service.id}`}>
                                        <div className="ec-card__secondary-img" style={{height: "200px"}}>
                                          <img src={service.image.url} alt={service.title}/>
                                        </div>
                                        <div
                                            className="ec-card__secondary-name text-capitalize font-weight-bold pl-2 text-center"
                                            style={{fontSize: 16}}>{service.title}</div>
                                      </Link>
                                    </div>
                                ))
                            : [...Array(8)].map((_, i) => (
                                <div className="col-3 mb-3" key={i}>
                                  <div className="skeleton-box" style={{height: '80px', borderRadius: "5px"}}></div>
                                  <div className="skeleton-box mt-2" style={{height: '20px', borderRadius: "5px"}}></div>
                                </div>
                            ))
                        }
                      </div>
                      {/* <Link to="/search-projects" className="ec-btn__primary ec-btn__primary--typeB ec-btn__primary--border-radius w-100 mt-1 d-flex align-items-center justify-content-center">
                      <span className="mr-2">VIEW ALL SERVICES</span>
                      <i className="fa fa-arrow-right"></i>
                    </Link> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Loading Indicator */}
              {this.state.removeLoding && (
                  <div className="loading-overlay">
                    <div className="loading-spinner">Loading...</div>
                  </div>
              )}
          </section>
        </Main>
      </div>
  );
  }
  }

  const mapStateToProps = state => ({
  dashData: state.dashoardData,
  notifications: state.notificationList.notification_list,
  projectsData: state.allProjectsData,
  projectAvailable: state.projectAvailable,
  conversation: state.conversations,
});

export default connect(mapStateToProps, { activateChatBox })(DashBoard);